import type { FeePolicy, StoreProvider } from "@hobbyshopify/backend-client";
import { Rx } from "subtree.js/core";

export class OnboardingPaymentsState {
  readonly storeId = new Rx<string | null>(null);
  /** The business sells from a booth at shows, so premises of its own are worth mentioning. */
  readonly sellsAtShows = new Rx(false);
  /** Stripe as the provider reports it; null until connected or while unknown. */
  readonly connection = new Rx<StoreProvider | null>(null);
  /** True until the providers have answered once for this shop. */
  readonly providersLoading = new Rx(true);
  /** The rates the wizard quotes; null until read. */
  readonly fees = new Rx<FeePolicy | null>(null);
  readonly error = new Rx<string | null>(null);
  readonly busy = new Rx(false);
}

export abstract class OnboardingPaymentsActions {
  /** Starts or resumes Stripe's hosted onboarding, leaving the breadcrumb that brings the return here. */
  abstract connect(): Promise<void>;
  /** Re-reads the account server-side, for a review that is Stripe's to finish. */
  abstract recheck(): Promise<void>;
  abstract openDashboard(): Promise<void>;
  /** Leaves the wizard, recording that payments were deferred. */
  abstract finish(): void;
}
